<script lang="ts">
  import List from './List.svelte'
  import Edit from './Edit.svelte'
  import NextSteps from './NextSteps.svelte'

  interface Props {
    mode: 'index' | 'new' | 'edit' | 'next-steps'
    triggerHashid?: string
    inboundEmailDomain?: string
  }

  let { mode, triggerHashid = '', inboundEmailDomain = '' }: Props = $props()
</script>

{#if mode === 'index'}
  <List {inboundEmailDomain} />
{:else if mode === 'new'}
  <Edit hashid={null} />
{:else if mode === 'edit'}
  <Edit hashid={triggerHashid} />
{:else if mode === 'next-steps'}
  <NextSteps hashid={triggerHashid} />
{/if}
